import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import SignUp from "./-components/SignUp";

export const Route = createFileRoute("/_unauthenticated/sign-up")({
  component: SignUp,
  validateSearch: z.object({
    utm_source: z.string().optional(),
    utm_medium: z.string().optional(),
    utm_campaign: z.string().optional(),
    first_name: z.string().optional(),
    last_name: z.string().optional(),
    phone: z.string().optional(),
    email: z.string().optional(),
  }),
});
